/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Left_TitleInputs */



/**
* | output |
* | --- |
* | "Align Left" |
*
* @param {Align_Left_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_left_title = /** @type {((inputs?: Align_Left_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Left_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner a Gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Linksbündig ausrichten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allinea a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выровнять по левому краю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alinear a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左揃え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाईं ओर संरेखित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alinhar à esquerda")
	return /** @type {LocalizedString} */ ("Align Left")
});